import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-background-50 text-xl">
                <i className="ri-bubble-chart-line" aria-hidden="true" />
              </span>
              <span className="font-heading text-2xl">小水看番</span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-accent-100/80">
              精选泡面番、三分钟短番与日常搞笑下饭番，帮你轻松找到值得一口气看完的宝藏短番。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50">内容导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-accent-100/80">
              <li><Link to="/library" className="hover:text-background-50 transition-colors">番剧库</Link></li>
              <li><Link to="/about" className="hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/faq" className="hover:text-background-50 transition-colors">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50">热门分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-accent-100/80">
              <li><Link to="/library" className="hover:text-background-50 transition-colors">泡面番</Link></li>
              <li><Link to="/library" className="hover:text-background-50 transition-colors">三分钟短番</Link></li>
              <li><Link to="/library" className="hover:text-background-50 transition-colors">日常搞笑</Link></li>
              <li><Link to="/library" className="hover:text-background-50 transition-colors">下饭番</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-accent-100/80">
              <li><a href="mailto:hello@xiaoshuikanfan.com" className="hover:text-background-50 transition-colors">hello@xiaoshuikanfan.com</a></li>
              <li className="text-accent-100/60">工作日 10:00 - 19:00 在线</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-accent-100/15 pt-6 text-xs text-accent-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 小水看番 · 为你精选每一部下饭短番</p>
          <p className="flex items-center gap-1.5">
            轻松刷完，不占时间
            <i className="ri-heart-3-fill text-primary-400" aria-hidden="true" />
          </p>
        </div>
      </div>
    </footer>
  );
}